import React, { useEffect, useState } from 'react';
import Tab from '@material-ui/core/Tab';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, UncontrolledTooltip } from 'reactstrap';
import * as commonActions from '@common/common.action';
import { useDispatch } from 'react-redux';
import Blocos from './Blocos';
import Laminas from './Laminas';
import LaminasCitologia from './LaminasCitologia';
import LaminasCongelacao from './LaminasCongelacao';
import './styles.css';
import IntlMessage from '../../../helpers/intlMessage';

export default function ControleBlocosLaminas ({
  showModalControle,
  laudo,
  onModal
}) {
  const dispatch = useDispatch();
  const [modalAberto, setModalAberto] = useState(false);
  const [currentTab, setCurrentTab] = useState('0');
  const [laudoId, setLaudoId] = useState(0);
  const [laudoInfo, setLaudoInfo] = useState({});

  useEffect(() => {
    setTimeout(() => setCurrentTab('1'), 200);
    if (laudo) {
      const { paciente, nrExame } = laudo;
      setLaudoId(laudo.laudo);
      setLaudoInfo({ paciente, nrExame });
    }
  }, [laudo]);

  useEffect(() => {
    setModalAberto(showModalControle);
    dispatch(commonActions.showModal(showModalControle));
  }, [showModalControle]);

  const toggle = () => {
    setModalAberto(!modalAberto);
    dispatch(commonActions.showModal(!modalAberto));
    onModal(!modalAberto);
  };

  const changeTab = (event, tab) => {
    setCurrentTab(tab);
  };

  return (
    <Modal
      className='modal-xl modal-controle-blocos-laminas'
      backdrop={false}
      keyboard={true}
      centered
      isOpen={modalAberto}
      toggle={toggle}
    >
      <ModalHeader toggle={toggle}>
        <div className='modal-controle-blocos-laminas-header'>
          <span><IntlMessage id = "dashboards.examDetail.blockandBladeControl"/></span>
          <div>
            <span>
              <IntlMessage id = "dashboards.examDetails.exam"/> <strong>{laudoInfo.nrExame}</strong>
            </span>
            <span
          id={`paciente_${laudoInfo.id}`}
          style={{ fontSize: '14px', marginBottom: '2px' }}
        >
          <strong><IntlMessage id = "dashboards.examDetail.patient"/> </strong>
          {laudoInfo.paciente}
            <UncontrolledTooltip placement='top' target={`paciente_${laudoInfo.id}`}>
              {laudoInfo.paciente}
            </UncontrolledTooltip>
        </span>
        {laudoInfo.pacienteNomeSocial &&
        <span
          id={`nomesocial_${laudoInfo.id}`}
          style={{ fontSize: '14px', marginBottom: '2px' }}
        >
          <strong><IntlMessage id = "dashboards.examDetails.socialName"/> </strong>
          {laudoInfo.pacienteNomeSocial}  
            <UncontrolledTooltip placement='top' target={`nomesocial_${laudoInfo.id}`}>
              {laudoInfo.pacienteNomeSocial}
            </UncontrolledTooltip>
          </span>}
          </div>
        </div>
      </ModalHeader>

      <ModalBody>
        <TabContext value={currentTab}>
          <AppBar position='static' color='default'>
            <Tabs
              value={currentTab}
              onChange={changeTab}
              variant='scrollable'
              indicatorColor='primary'
              textColor='primary'
              aria-label='scrollable force tabs example'
            >
              <Tab
                icon={<i className='tab-icons fas fa-pager'></i>}
                label={<IntlMessage id = "dashboards.examDetail.macroscopicMap"/>}
                value='1'
              />

              <Tab
                icon={<i className='tab-icons fas fa-microscope'></i>}
                label={<IntlMessage id = "dashboards.examDetail.technicalArea"/>}
                value='2'
              />

              <Tab
                icon={<i className='tab-icons fas fa-disease'></i>}
                label={<IntlMessage id = "dashboards.examDetail.generalCytology"/>}
                value='3'
              />
              <Tab
                icon={<i className='tab-icons fas fa-igloo'></i>}
                label={<IntlMessage id = "dashboards.examDetail.freezing"/>}
                value='4'
              />

              <Tab value='0' disabled></Tab>
            </Tabs>
          </AppBar>

          <TabPanel value='0'></TabPanel>

          <TabPanel value='1'>
            <Blocos laudo={laudoId} />
          </TabPanel>

          <TabPanel value='2'>
            <Laminas laudo={laudoId} />
          </TabPanel>

          <TabPanel value='3'>
            <LaminasCitologia laudo={laudoId} />
          </TabPanel>

          <TabPanel value='4'>
            <LaminasCongelacao laudo={laudoId} />
          </TabPanel>
        </TabContext>
      </ModalBody>

      <ModalFooter>
        <Button onClick={toggle} className={`button-cancel`} color='secondary'>
         <IntlMessage id = "dashboards.examDetail.close"/>
        </Button>
      </ModalFooter>
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/pages/main/ControleBlocosLaminas/index.js